/* eslint-disable global-require */
import Echo from 'laravel-echo';
import { TokenService } from './local-storage';

function getParams() {
  if (process.env.VUE_APP_BROADCAST_DRIVER === 'pusher') {
  // pusher params
    window.Pusher = require('pusher-js');
    return {
      broadcaster: 'pusher',
      key: process.env.VUE_APP_PUSHER_KEY,
      forceTLS: true,
      cluster: 'ap1',
      // authEndpoint: `${process.env.VUE_APP_API_URL}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${TokenService.get()}`,
        },
      },
    };
  }

  if (process.env.VUE_APP_BROADCAST_DRIVER === 'socket.io') {
  // socket.io params
    window.io = require('socket.io-client');
    return {
      broadcaster: 'socket.io',
      host: process.env.VUE_APP_SOCKET_HOST,
      authEndpoint: `${process.env.VUE_APP_API_URL}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${TokenService.get()}`,
        },
      },
    };
  }
  console.error('Invalid Broadcast Driver');
  return {};
}

// global service
const globalEchoService = new Echo(getParams());
export default {
  subscribeChannel(channelName) {
    return globalEchoService.channel(channelName);
  },
  subscribeChannelPrivate(channelName) {
    return globalEchoService.private(channelName);
  },
  leaveChannel(channelName) {
    return globalEchoService.leaveChannel(channelName);
  },
  leaveChannelPrivate(channelName) {
    return globalEchoService.leave(channelName);
  },
};

// local service
export function initEchoService() {
  const localEchoService = new Echo(getParams());
  return {
    subscribeChannel(channelName) {
      return localEchoService.channel(channelName);
    },
    leaveChannel(channelName) {
      return localEchoService.leaveChannel(channelName);
    },
  };
}
